import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import { CopyAttachment } from '@app/store/transport-layer/types/copyAttachment';

export interface copyRequesterAttachmentResponse {
  attachments: CopyAttachment[];
}

export function copyDraftRequesterAttachments(draftId: string) {
  return requestApi<{ attachments: CopyAttachment[] }>({
    method: 'POST',
    url: withDocument(`/drafts/${draftId}/attachments/copy`),
    credentials: true,
  }).then((response) => response.data);
}
